import { BigDecimal, LogisticaTipoFormaPagoDominio } from "@pcgerente-node/pcg-comun";
import { logistica_GUIA, logistica_MANIFIESTO_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { Link } from "react-router-dom";
import style from "./CardLiquidacionRuta.module.css";

const CardsManifiestosDetallesEnRuta: React.FC<{manifiestosDetalles?:logistica_MANIFIESTO_DETALLE[]}> = ({manifiestosDetalles}) => {

    const IndividualCard: React.FC<{ guia?:logistica_GUIA, uuidManifiestoDetalle: string }> =({guia, uuidManifiestoDetalle}) =>{
        return(
            guia?
            <Link to={`/home/liquidarRuta/${uuidManifiestoDetalle}`} rel="noopener noreferrer" className={style.cardContainer}>
                    <span>{`${guia?.DOCUMENTO?.descripcion} #${guia.numeroDocumento}`}</span>
                    <span>{new Date(guia.fechaEmision).toLocaleDateString()}</span>
                    {guia?.entregaUrgente?
                        <span className="text-danger">Entrega Urgente</span>
                        :<></>
                    }
                    <span>Total ${new BigDecimal(guia?.total).toFixed(2)}</span>
                    <span>{LogisticaTipoFormaPagoDominio.obtener(guia.tipo).descripcion}</span>
                    <span>{guia?.CLIENTE_DESTINATARIO?.razonSocial.toUpperCase()}</span>
                    <span>{!guia?.CIUDAD_DESTINO?.permiteEntregarConManifiesto?"Con manifiesto (Viaje)":"Solo con ruta"}</span>
            </Link>
            :<></>
        )
    } 
    // Contenedor de cartas
    return(
        manifiestosDetalles?
        <div className={style.mainContainer}>
            {manifiestosDetalles.map((md, i) =>
                <IndividualCard
                    guia={md.logistica_GUIA}
                    key={i}
                    uuidManifiestoDetalle={md.id}
                />
            )}
        </div>
        :<div className="d-flex justify-content-center">
            <span className="text-center text-danger pt-2" style={{ fontSize: "1.5rem" }}>"No se econtraron Guias" </span>
        </div>
    )
}
export default CardsManifiestosDetallesEnRuta